import { StyleSheet } from 'react-native';
import { Layout } from '@ui-kitten/components';
import MainMenuContainer from 'src/features/menu/MainMenuContainer';
import React from 'react';
import { RootStackScreenProps } from 'src/core';

//styles
const styleContainer = StyleSheet.create({
  screenContainer: {
    flex: 1
  },
  safeAreaView: { flex: 1 }
});

const MainMenuScreen = ({ route }: RootStackScreenProps<'Settings'>) => {
  const chCallbackCode = route.params?.code;
  //view
  return (
    <Layout level="2" style={styleContainer.screenContainer}>
      <MainMenuContainer key={chCallbackCode} code={chCallbackCode} />
    </Layout>
  );
};

export default MainMenuScreen;
